/* eslint-disable import/default */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import configureStore, { getReduxHistory } from './store/configureStore';
import Root from './Root';
import './styles/styles.scss';

const store = configureStore();
const history = getReduxHistory();

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <Root store={store} history={history}/>,
);
